import { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen } from "../../../_metronic";
import DashboardPage from "../dashboard/DashboardPage";
import OnboardingPage from "../onboarding/OnboardingPage";
import EquipePage from "../equipe/EquipePage";
import ConfiguracoesPage from "../onboarding/configuracoes/ConfiguracoesPage";
import ViagemPage from "../viagem/ViagemPage";

export default function HomePage() {
    const { status } = useSelector(
        ({ onboarding }) => onboarding,
        shallowEqual
    );

    const onboarding_concluido = status === "COMPLETO";

    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <Redirect exact from="/" to="/inicio" />

                <Route
                    path="/inicio"
                    exact
                    render={(props) =>
                        onboarding_concluido ? (
                            <DashboardPage {...props} />
                        ) : (
                            <OnboardingPage {...props} />
                        )
                    }
                />

                <Route path="/viagens" component={ViagemPage} />
                <Route path="/equipe" component={EquipePage} />
                <Route path="/configuracoes" component={ConfiguracoesPage} />

                <Redirect to="/error/error-v6" />
            </Switch>
        </Suspense>
    );
}
